<template>
  <tg-app-bar
    ref="appbar"
    :height="height"
    :size="showHeaderPaper ? 'float' : size"
    :title="title"
    :type="type"
    :prominent="showHeaderPaper ? false : true"
    class="tg-app--header"
    @on-bars-click="handleBarsClick"
  >
    <el-row
      type="flex"
      align="middle"
      justify="start"
      class="tg-header--content"
    >
      <tg-header-logo :site="site"></tg-header-logo>
      <el-row
        type="flex"
        align="middle"
        justify="start"
        class="tg-header--title"
      >
        <div class="title">
          <slot>{{ title }}</slot>
        </div>
      </el-row>
    </el-row>
    <template slot="float">
      <div class="header-paper-float">
        <div class="header-paper-row" v-show="showHeaderPaper">
          <div class="header-paper-card">
            <div class="title">
              <!-- 本月提成 -->
              <b>{{ $t("column.month_commission") }}</b>
            </div>
            <div class="content">
              {{ thisMonthCommission }}
            </div>
            <i
              class="el-icon-download clickable"
              @click="handleExport(1, thisMonthCommission)"
              v-show="thisMonthCommission != '0.00'"
            ></i>
          </div>
          <span class="header-paper-divider">-</span>
          <div class="header-paper-card">
            <div class="title">
              <!-- 本月反佣奖金 -->
              <b>{{ $t("column.month_commission_bonus") }}</b>
            </div>
            <div class="content">
              {{ thisMonthReward }}
            </div>
            <i
              class="el-icon-download clickable"
              v-show="thisMonthReward != '0.00'"
              @click="handleExport(2, thisMonthReward)"
            ></i>
          </div>
          <span class="header-paper-divider">-</span>
          <div class="header-paper-card">
            <div class="title">
              <!-- 本月活动支出 -->
              <b>{{ $t("column.month_activity_expenses") }}</b>
            </div>
            <div class="content">
              {{ thisMonthActivityExpense }}
            </div>
            <i
              class="el-icon-download clickable"
              @click="handleExport(3, thisMonthActivityExpense)"
              v-show="thisMonthActivityExpense != '0.00'"
            ></i>
          </div>
          <span class="header-paper-divider">=</span>
          <div class="header-paper-card purple">
            <div class="title">
              <!-- 本月收入 -->
              <b>{{ $t("column.month_income") }}</b>
            </div>
            <div
              class="content"
              :class="{
                'text-finance-green': thisMonthIncome > 0,
                'text-finance-red': thisMonthIncome < 0,
              }"
            >
              {{ thisMonthIncome }}
            </div>
          </div>
          <div class="header-paper-card purple">
            <div class="title">
              <!-- 上月收入 -->
              <b>{{ $t("column.last_month_income") }}</b>
            </div>
            <div
              class="content"
              :class="{
                'text-finance-green': lastMonthIncome > 0,
                'text-finance-red': lastMonthIncome < 0,
              }"
            >
              {{ lastMonthIncome }}
            </div>
          </div>
        </div>
        <button
          class="tg-btn--extend-top-bottom"
          :class="{ active: showHeaderPaper }"
          @click="handleHeaderPaper()"
        ></button>
      </div>
    </template>

    <template slot="tools">
      <tg-toolbar-btn class="tg-app--btn">
        <button class="user" @click="handleProfile"></button>
        <span @click="handleProfile">{{ user.username }}</span>
      </tg-toolbar-btn>
      <tg-toolbar-btn class="tg-app--btn is-disabled-hover">
        <button class="logout" @click="handleLogout"></button>
        <span>{{ $t("component.header.loginOut") }}</span>
      </tg-toolbar-btn>
    </template>
    <template v-slot:extension>
      <template>
        <tg-marquee :marquee="marquee"></tg-marquee>
      </template>
    </template>
  </tg-app-bar>
</template>

<script>
import TgAppBar from "@/components/bars/TgAppBar";
import TgToolbarBtn from "@/components/bars/TgToolbarBtn";
import TgMarquee from "@/components/marquee/TgMarquee";
import { headerProps } from "./utils";
import TgHeaderLogo from "@/components/header/TgHeaderLogo";
import formatter from "@/utils/formatter";

import apis from "@/apis";
// import { convertToRows, flatColumns } from "@/utils/table";
// import { summary } from "@/utils/table";
// import str from "@/utils/str";
import xlsx from "@/utils/xlsx";

const exportHandlers = {
  1: "exportBet", // 本月提成
  2: "exportReward", // 本月反傭
  3: "exportActivity", // 本月活動支出
};
export default {
  name: "DarkPurpleHeader",
  components: {
    TgAppBar,
    TgToolbarBtn,
    TgMarquee,
    TgHeaderLogo,
  },
  props: headerProps,
  data() {
    return {
      showMarquee: false,
      showHeaderPaper: false,
    };
  },
  computed: {
    thisMonthCommission() {
      return (
        formatter.decimal(
          this.$store.state.app.earningsStatistic.thisMonthCommission,
          [2]
        ) || "0.00"
      );
    },
    thisMonthReward() {
      return (
        formatter.decimal(
          this.$store.state.app.earningsStatistic.thisMonthReward,
          [2]
        ) || "0.00"
      );
    },
    thisMonthActivityExpense() {
      return (
        formatter.decimal(
          this.$store.state.app.earningsStatistic.thisMonthActivityExpense,
          [2]
        ) || "0.00"
      );
    },
    thisMonthIncome() {
      return (
        formatter.decimal(
          this.$store.state.app.earningsStatistic.thisMonthIncome,
          [2]
        ) || "0.00"
      );
    },
    lastMonthIncome() {
      return (
        formatter.decimal(
          this.$store.state.app.earningsStatistic.lastMonthIncome,
          [2]
        ) || "0.00"
      );
    },
    // {"thisMonthCommission":"0.00","thisMonthReward":"18.76","thisMonthActivityExpense":"0.00","thisMonthIncome":"-18.76","lastMonthIncome":"-18.76"}
  },
  methods: {
    handleLogout() {
      this.$emit("on-logout");
    },
    handleBarsClick(e) {
      this.$emit("on-bars-click", e);
    },
    handleProfile() {
      this.$emit("on-profile");
    },
    handleHeaderPaper() {
      let showHeaderPaper = !this.showHeaderPaper;
      this.showHeaderPaper = showHeaderPaper;
      this.$store.commit("app/update", { showHeaderPaper: showHeaderPaper });
    },
    handleExport(type, value) {
      if (value == "0.00") {
        return false;
      }
      apis.accounts.statistic
        .getEarningsStatisticExport({ type })
        .then((response) => {
          this[exportHandlers[type]](response);
        });
    },
    exportBet(response) {
      let columns = response.columns;
      let amountColumns = response.amountColumns;
      let header = columns.map((c) => c.title);
      xlsx.sheetGeneral((xs) => {
        let ws = xs.XLSX.utils.json_to_sheet(
          response.data.list.map((row) => {
            row.platform = this.$t(
              "component.label.source_type." + row.platform
            );
            return row;
          }),
          { header: columns.map((c) => c.name) }
        );

        xs.XLSX.utils.sheet_add_aoa(ws, [[""]], {
          header: header,
          skipHeader: true,
          origin: -1,
        });

        amountColumns.forEach((r) => {
          if (r.name == "percent") {
            r.title = this.$user.username + r.title;
          }
          xs.XLSX.utils.sheet_add_aoa(ws, [[r.title, response.data[r.name]]], {
            header: header,
            skipHeader: true,
            origin: -1,
          });
        });

        xs.XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
        let date = new Date().toISOString().replace(/[-:.]/g, "");
        xs.exportExcel(
          ws,
          date + "-" + this.$user.username + "_month_commission"
        );
      });
    },
    exportActivity(response) {
      let columns = response.columns;
      let amountColumns = response.amountColumns;
      let header = columns.map((c) => c.title);
      xlsx.sheetGeneral((xs) => {
        let ws = xs.XLSX.utils.json_to_sheet(response.data.list, {
          header: columns.map((c) => c.name),
        });

        xs.XLSX.utils.sheet_add_aoa(ws, [[""]], {
          header: header,
          skipHeader: true,
          origin: -1,
        });

        amountColumns.forEach((r) => {
          if (r.name == "percent") {
            r.title = this.$user.username + r.title;
          }
          xs.XLSX.utils.sheet_add_aoa(ws, [[r.title, response.data[r.name]]], {
            header: header,
            skipHeader: true,
            origin: -1,
          });
        });

        xs.XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
        let date = new Date().toISOString().replace(/[-:.]/g, "");
        xs.exportExcel(
          ws,
          date + "-" + this.$user.username + "_month_event_expenses"
        );
      });
    },
    exportReward(response) {
      let columns = response.columns;
      let amountColumns = response.amountColumns;
      let header = columns.map((c) => c.title);
      xlsx.sheetGeneral((xs) => {
        let ws = xs.XLSX.utils.json_to_sheet(
          response.data.list.map((row) => {
            row.platform = this.$t(
              "component.label.source_type." + row.platform
            );
            return row;
          }),
          { header: columns.map((c) => c.name) }
        );

        xs.XLSX.utils.sheet_add_aoa(ws, [[""]], {
          header: header,
          skipHeader: true,
          origin: -1,
        });

        amountColumns.forEach((r) => {
          if (r.name == "percent") {
            r.title = this.$user.username + r.title;
          }
          xs.XLSX.utils.sheet_add_aoa(ws, [[r.title, response.data[r.name]]], {
            header: header,
            skipHeader: true,
            origin: -1,
          });
        });

        xs.XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
        let date = new Date().toISOString().replace(/[-:.]/g, "");
        xs.exportExcel(
          ws,
          date + "-" + this.$user.username + "_month_rebate_bonus"
        );
      });
    },
  },
  watch: {
    $route() {
      this.showMarquee = this.$route.name == "dashboard";
      this.$nextTick(() => {
        this.$refs.appbar.parseExtendheight();
      });
    },
  },
};
</script>
